import {
  Button,
  Row,
  Form,
  Input,
  Space,
  Table,
  Col,
  Tooltip,
  Select,
  Upload,
  Popover,
  Dropdown,
  Menu,
  Empty,
  ConfigProvider,
  Card,
  Statistic,
} from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, Fragment } from "react";
import "./index.css";
import {
  CommonStore,
  ANumberManageStore,
  UserAccountStore,
  XNumberManageStore,
} from "../../../../store";
import UpdateOrAdd from "./update_or_add";
import TemplatePreview from "./template_preview";
import type { MenuProps, UploadProps } from "antd";
import {
  MoreOutlined,
  InfoCircleOutlined,
  DownOutlined,
} from "@ant-design/icons";

const { Column } = Table;

const addProps: UploadProps = {
  beforeUpload(info) {
    return false;
  },
  onChange: (info) => {
    const form = new FormData();
    form.append("file", info.file as any);
    ANumberManageStore.templateModal.open("add");
    ANumberManageStore.addPreview(form, "add");
  },
};
const updateProps: UploadProps = {
  beforeUpload(info) {
    return false;
  },
  onChange: (info) => {
    const form = new FormData();
    form.append("file", info.file as any);
    ANumberManageStore.templateModal.open("update");
    ANumberManageStore.editPreview(form, "update");
  },
};
const deleteProps: UploadProps = {
  beforeUpload(info) {
    return false;
  },
  onChange: (info) => {
    const form = new FormData();
    form.append("file", info.file as any);
    ANumberManageStore.templateModal.open("delete");
    ANumberManageStore.deletePreview(form, "delete");
  },
};

function ANumberManage() {
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    form.setFieldsValue({
      callInitializerNumberPoolNo: null,
      status: null,
      phoneNumber: "",
      remark: "",
    });
    resetSearchbth();
  }, []);
  const getFormData = (
    changeValue: powerSearchData,
    allValues: powerSearchData
  ) => {
    ANumberManageStore.setSearchForm({ ...allValues });
  };

  const searchBtn = () => {
    ANumberManageStore.resetPage();
    ANumberManageStore.manageAPoolNumberPage();
  };
  const resetSearchbth = () => {
    ANumberManageStore.setSearchForm({});
    searchBtn();
  };

  const addPower = (data?: any) => {
    if (data) {
      ANumberManageStore.getAllAPool(1);
      UserAccountStore.addOrUpdateModal.open("update", data);
    } else {
      ANumberManageStore.getAllAPool(1);
      UserAccountStore.addOrUpdateModal.open("add");
    }
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "1") {
      return addPower();
    }
  };
  const items = [
    {
      label: "单个新增",
      key: "1",
      style: { display: CommonStore.pagePermission.manageable ? "" : "none" },
    },
    {
      label: (
        <Upload {...addProps} showUploadList={false}>
          <span>批量新增</span>
        </Upload>
      ),
      key: "2",
      style: { display: CommonStore.pagePermission.manageable ? "" : "none" },
    },
    {
      label: (
        <Upload {...updateProps} showUploadList={false}>
          <span>批量修改</span>
        </Upload>
      ),
      key: "3",
      style: { display: CommonStore.pagePermission.writable ? "" : "none" },
    },
    {
      label: (
        <Upload {...deleteProps} showUploadList={false}>
          <span style={{ color: "red" }}>批量删除</span>
        </Upload>
      ),
      key: "4",
      style: { display: CommonStore.pagePermission.manageable ? "" : "none" },
    },
    {
      key: "5",
      label: "下载模版",
      children: [
        {
          key: "5-1",
          label: (
            <a
              href={require("../../../../assets/template/pool_a_add.xlsx")}
              download={"A池新增模版"}
            >
              <span>新增</span>
            </a>
          ),
        },
        {
          key: "5-2",
          label: (
            <a
              href={require("../../../../assets/template/pool_a_update.xlsx")}
              download={"A池修改模版"}
            >
              <span>修改</span>
            </a>
          ),
        },
        {
          key: "5-3",
          label: (
            <a
              href={require("../../../../assets/template/pool_a_delete.xlsx")}
              download={"A池删除模版"}
            >
              <span>删除</span>
            </a>
          ),
        },
      ],
    },
  ];
  const moreOperationsClick = (e: any, record: any) => {
    if (e.key === "1") {
      return ANumberManageStore.deletePower(record);
    }
  };
  const moreOperations = (record: any) => {
    return [
      {
        label: "删除号码",
        key: "1",
        // show: CommonStore.pagePermission.manageable,
        style: {
          color: "red",
          display: CommonStore.pagePermission.manageable ? "" : "none",
        },
      },
    ];
  };
  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };

  return (
    <Fragment>
      <UpdateOrAdd></UpdateOrAdd>
      <TemplatePreview></TemplatePreview>
      <Row gutter={24} style={{ marginTop: "12px" }}>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="池号码总数"
              value={ANumberManageStore.statisticsData.totalCount}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="上周新增"
              value={ANumberManageStore.statisticsData.weekBasis}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="昨日新增"
              value={ANumberManageStore.statisticsData.dayBasis}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="已上架总数"
              value={ANumberManageStore.statisticsData.statusUpCount}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="待上架总数"
              value={ANumberManageStore.statisticsData.statusWaitUpCount}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="已禁用总数"
              value={ANumberManageStore.statisticsData.statusDisableCount}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
      </Row>
      <div style={{ height: "12px" }}></div>
      <div className="formContent">
        <Form
          form={form}
          initialValues={ANumberManageStore.searchForm}
          autoComplete="off"
          labelCol={{ span: 6 }}
          onValuesChange={getFormData}
        >
          <Row justify="start">
            <Col span={8}>
              <ConfigProvider renderEmpty={tableEmptyRender}>
                <Form.Item label="所属A池" name="callInitializerNumberPoolNo">
                  <Select
                    onChange={UserAccountStore.handleChange}
                    placeholder="请选择所属A池"
                  >
                    {Array.from(ANumberManageStore.getAllAPoolReadInfo)
                      ? ANumberManageStore.getAllAPoolReadInfo.map(
                          (value: any, index: any) => {
                            return (
                              <Option value={value.no} key={index}>
                                {value.name}
                              </Option>
                            );
                          }
                        )
                      : ""}
                  </Select>
                </Form.Item>
              </ConfigProvider>
            </Col>
            <Col span={8}>
              <Form.Item label="号码状态" name="status">
                <Select placeholder="请选择号码状态">
                  <Option value={"1"}>待上架</Option>
                  <Option value={"2"}>已上架</Option>
                  <Option value={"3"}>已禁用</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="号码" name="phoneNumber">
                <Input placeholder="请输入号码" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="备注" name="remark">
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
            <Col offset={2}>
              <Form.Item>
                <Space>
                  <Button type="primary" onClick={searchBtn}>
                    搜索
                  </Button>
                  <Button htmlType="reset" onClick={resetSearchbth}>
                    重置
                  </Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            {(CommonStore.pagePermission.writable ||
              CommonStore.pagePermission.manageable) && (
              <Col span={8} offset={16} style={{ marginBottom: "10px" }}>
                <Dropdown
                  dropdownRender={(menu) => (
                    <Menu onClick={handleMenuClick} items={items}></Menu>
                  )}
                >
                  <Button style={{ float: "right" }}>
                    <Space className="change">
                      变更
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Col>
            )}
          </Row>
        </Form>
      </div>
      <ConfigProvider renderEmpty={tableEmptyRender}>
        <Table
          dataSource={ANumberManageStore.tableData.records}
          rowKey={(record: { phoneNumberNo: string }) => record.phoneNumberNo}
          loading={ANumberManageStore.tableLoad}
          scroll={{ x: 1500 }}
          pagination={{
            current: ANumberManageStore.pageData.page,
            pageSize: ANumberManageStore.pageData.size,
            onChange: ANumberManageStore.pageData.changePage,
            pageSizeOptions: [10, 20, 50, 100],
            showSizeChanger: true,
            total: ANumberManageStore.tableData.total,
            showTotal: () => `共计${ANumberManageStore.tableData.total}条`,
            position: ["bottomLeft"],
          }}
        >
          <Column
            ellipsis={true}
            width={140}
            title="号码"
            dataIndex="phoneNumber"
            fixed={"left"}
            sorter={(a: any, b: any) => a.phoneNumber - b.phoneNumber}
            defaultSortOrder={"descend"}
            showSorterTooltip={false}
          />
          <Column
            width={100}
            title="编号"
            dataIndex="phoneNumberNo"
            render={(phoneNumberNo) => (
              <Tooltip placement="topLeft" title={phoneNumberNo}>
                <InfoCircleOutlined />
              </Tooltip>
            )}
          />
          <Column
            ellipsis={true}
            width={120}
            title="所属A池"
            dataIndex="callInitializerNumberPoolName"
          />
          <Column
            ellipsis={true}
            width={120}
            title="所属A池编号"
            dataIndex="callInitializerNumberPoolNo"
            render={(callInitializerNumberPoolNo) => (
              <Tooltip placement="topLeft" title={callInitializerNumberPoolNo}>
                <InfoCircleOutlined />
              </Tooltip>
            )}
          />
          <Column
            width={120}
            title="号码状态"
            ellipsis={true}
            dataIndex="status"
            render={(status) => {
              if (status === "1") {
                return <span>待上架</span>;
              } else if (status === "2") {
                return <span style={{ color: "#1677FF" }}>已上架</span>;
              } else if (status === "3") {
                return <span style={{ color: "red" }}>已禁用</span>;
              }
            }}
          />
          <Column
            title="所属A池状态"
            width={120}
            ellipsis={true}
            dataIndex="poolStatus"
            render={(poolStatus) => (poolStatus ? "启用" : "禁用")}
          />
          <Column
            ellipsis={true}
            width={120}
            title="基础运营商"
            dataIndex="carrier"
          />

          <Column
            ellipsis={true}
            width={200}
            title="创建时间"
            dataIndex="createTime"
          />
          <Column
            ellipsis={true}
            width={200}
            title="更新时间"
            dataIndex="updateTime"
          />
          <Column ellipsis={true} width={200} title="备注" dataIndex="remark" />
          <Column
            width={120}
            fixed={"right"}
            title={() => {
              return (
                <>
                  <Popover
                    placement="bottom"
                    content={() => {
                      return (
                        <ul style={{ width: "200px", padding: "0 0 0 21px" }}>
                          <li>操作号码需要为用户授予号码所在号池的编辑权限</li>
                        </ul>
                      );
                    }}
                  >
                    <InfoCircleOutlined className="tips" />
                  </Popover>
                </>
              );
            }}
            render={(text: string, record: any) => (
              <Space>
                {record.writeable && CommonStore.pagePermission.writable && (
                  <Button onClick={() => addPower(record)} size={"small"}>
                    编辑
                  </Button>
                )}
                {record.manageable && CommonStore.pagePermission.manageable && (
                  <Dropdown
                    // {...moreOperations}
                    dropdownRender={(menu) => (
                      <Menu
                        onClick={(e) => moreOperationsClick(e, record)}
                        className={"menuSty"}
                        items={moreOperations(record)}
                      ></Menu>
                    )}
                  >
                    <Button size={"small"}>
                      <MoreOutlined className={""} />
                    </Button>
                  </Dropdown>
                )}
              </Space>
            )}
          />
        </Table>
      </ConfigProvider>
    </Fragment>
  );
}

export default observer(ANumberManage);
